import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from './redux'
import preload from 'components/enhancer/preload'
import composeHOC from 'shared/utils/composeHOC'
import DataGrid from 'components/grid/DataGrid'
import Meta from 'components/layout/Meta';

class ShopAddress extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showProvince: false,
      selectedProvince: null,
      columns: [{
        field: 'name',
        label: '营业部名称',
        width: 165
      }, {
        label: '营业部地址',
        field: 'address',
        width: 455
      }, {
        label: '电话',
        field: 'phone',
        width: 190
      }]
    }
  }

  componentDidMount() {
    const postscribe = require('postscribe')
    postscribe('#mapScript', '<script src="https://api.map.baidu.com/api?key=7d9fbeb43e975cd1e9477a7e5d5e192a&v=1.0&services=false"><\/script>')
  }

  onSelectProvince(province) {
    this.props.getCityList(province.id).then((result) => {
      this.setState({
        selectedCity: null,
        selectedProvince: province,
        cityList: result.data,
        showProvince: false
      })
    })
  }

  onSelectCity(city) {
    this.setState({
      selectedCity: city,
      showCity: false
    })
  }

  onProvinceSelectorClick = () => {
    this.setState({
      showProvince: !this.state.showProvince,
      showCity: false
    })
  }

  onCitySelectorClick = () => {
    this.setState({
      showProvince:false,
      showCity: !this.state.showCity
    })
  }

  searchShop = () => {
    this.props.getShopList(this.getSearchId(), 1).then((result) => {
      this.setState({
        shopList: result.data.items,
        shopPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      })
    })
  }

  getSearchId() {
    const province = this.state.selectedProvince
    const city = this.state.selectedCity
    let searchId = ''
    if (city && city.id) {
      searchId = city.id
    } else if (province && province.id) {
      searchId = province.id
    }
    return searchId
  }

  setPage(page) {
    this.props.getShopList(this.getSearchId(), page).then((result) => {
      this.setState({
        shopList: result.data.items,
        shopPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      })
    })
  }

  onShopClick(shop) {
    const {
      lan,
      lat,
      city,
      phone,
      address
    } = shop
    var map ,point,marker,infoWindow
    var sContent =
    '<span style=\'font-size: 18px;\'>'+city+'</span><br><span style=\'font-size: 14px;\'>'+phone+'</span>' +
    '<p style=\'font-size:13px\'>'+address+'</p>' +
    '</div>'

    map = new BMap.Map('container')
    point = new BMap.Point(lan,lat)
    marker = new BMap.Marker(point)
    infoWindow = new BMap.InfoWindow(sContent)  // 创建信息窗口对象
    map.centerAndZoom(point, 18)
    map.addOverlay(marker)
    marker.openInfoWindow(infoWindow)
    $('.addressMap').hide()
    $('.addressDetail').show()
  }


  render() {

    let {
      shopList,
      shopPagination,
      columns,
      style,
      showProvince,
      showCity,
      cityList,
      selectedProvince,
      selectedCity
    } = this.state

    if (!shopList) {
      shopList = this.props.shopList
    }

    if (!shopPagination) {
      shopPagination = this.props.shopPagination
    }

    const {
      provinceList
    } = this.props



    const workProvinceStyle = {
      display: showProvince ? 'block': 'none'
    }

    return (
      <div className="storeAddress rightCon">
        <Meta location={this.props.location} title="门店地址-关于我们"/>
        <div id="mapScript"></div>
        <div className="mgauto">
          <h3>
            门店地址
            <p>OUR LOCATIONS</p>
            <span className="redLine"></span>
          </h3>

          <div className="addressCon addressDetail" style={{display: 'none' }} id="container"></div>

          <div className="addressCon addressMap" style={{width: 760, height: 530, marginBottom: 0}}>
            <img src="/static/images/map.png" />
          </div>


          <form method="post" id="pageinationForm">
            <input type="hidden" id="currentpage" name="currentpage" />
            <div className="searchSelect clearfix">
              <div className="preInformation clearfix">
                <div className="clearfix">
                  <div id="provinceSelect" className="select_box">
                    <input type="text" placeholder="选择省份" readOnly="readonly" name="province" value={selectedProvince && selectedProvince.name} id="province" onClick={this.onProvinceSelectorClick} />
                    <input type="hidden" name="provinceCode" value="" id="provinceCode" />
                    <div id="workProvince" className="selectListArea" style={workProvinceStyle}>
                      <ul id="searchProvince">
                        {provinceList && provinceList.map((province, i) => {
                          return (<li key={i}><a style={{cursor: 'pointer'}} onClick={this.onSelectProvince.bind(this, province)}>{province.name}</a></li>)
                        })}
                      </ul>
                    </div>
                  </div>
                  <div id="citySelect" className="select_box unSelect">
                    <input type="text" placeholder="城市查询" name="city" value={selectedCity && selectedCity.name} readOnly="readonly" id="city" onClick={this.onCitySelectorClick} />
                    <div id="workCity" className="selectListArea" style={{display: showCity ? 'block' : 'none'}}>
                      <ul id="searchCity">
                        {cityList && cityList.map((city, i) => {
                          return (<li key={i}><a style={{cursor: 'pointer'}} onClick={this.onSelectCity.bind(this, city)}>{city.name}</a></li>)
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className="searchBtn" id="btnSearch" onClick={this.searchShop}></div>
                </div>
              </div>
            </div>
          </form>
          {(shopList && shopList.length)
            ?
            <DataGrid
              setPage={this.setPage.bind(this)}
              columns={columns}
              items={shopList}
              pagination={shopPagination}
              linkPrefix="/aboutUs/shopAddress/"
              onRowClick={this.onShopClick.bind(this)} />
            : (<dl className="noMessage">
                <dt>很抱歉！</dt>
                <dd>没有找到您需要的门店～</dd>
              </dl>)
          }
          <div className="addressDetail clearfix">
            <img src="/static/images/pic1.jpg" />
            <dl>
              <dt>中腾信金融信息服务（上海）有限公司</dt>
              <dd>客服热线：4009160160</dd>
              <dd>E-mail：ctcf@chinatopcredit.com</dd>
              <dd>资金合作：ZIJIN@chinatopcredit.com</dd>
              <dd>网址：www.chinatopcredit.com</dd>
              <dd>地址：上海市虹口区四川北路859号中信广场18楼1805室</dd>
              <dd>邮编：200085</dd>
            </dl>
          </div>
        </div>
      </div>
    )
  }
}



export default composeHOC(
  connect(state => ({
    provinceList: state.aboutUs.provinceList,
    shopList: state.aboutUs.shopList,
    shopPagination: state.aboutUs.shopPagination
  }), actions),
  preload(({dispatch}) => {
    return Promise.all([
      dispatch(actions.getProvinceList()),
      dispatch(actions.getShopList('', 1))
    ])
  })
)(ShopAddress)



// WEBPACK FOOTER //
// ./modules/aboutUs/ShopAddress.js